import loadAudioBufferFromFileUrl from './../audio/loader';
class AudioFile {
    constructor(url) {
        this.url = url;
    }
    async init() {
        this.audioBuffer = await loadAudioBufferFromFileUrl(this.url);
        this.duration = this.audioBuffer.duration;
    }
}
export default AudioFile;
export { AudioFile, };
